export default __webpack_public_path__ + "static/logo_zapier-bc89de902f8f07964d6e3bb0a489249e.jpg";